import './firebase'
import Vue from 'vue'
import shipments from './components/Shipments.vue'
import navBar from './components/Nav.vue'
import home from './components/Home.vue'
import stats from './components/Stats.vue'
import emergence from './components/Emergence.vue'
import plants from './components/Plants.vue'
import batch from './components/Batch.vue'
import butterflies from './components/Butterflies.vue'
import editButterfly from './components/EditButterfly.vue'
import butterflyGallery from './components/ButterflyGallery.vue'
import butterflyView from './components/ButterflyView.vue'
import plantGallery from './components/PlantGallery.vue'
import excel from './components/Excel.vue'
import shipmentSearch from './components/ShipmentSearch.vue'
import butterflySearch from './components/ButterflySearch.vue'
import customize from './components/Customize.vue'
import developer from './components/Developer.vue'
import {rtdbPlugin} from 'vuefire'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueGoogleCharts from 'vue-google-charts'
import VueRouter from 'vue-router'
import Auth from '@okta/okta-vue'
import JsonCSV from 'vue-json-csv'
import { VueCsvImport } from 'vue-csv-import';
 
Vue.component('downloadCsv', JsonCSV)
Vue.component('vueCsvImport', VueCsvImport)

Vue.config.productionTip = false;

Vue.use(rtdbPlugin);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
Vue.use(VueGoogleCharts);
Vue.use(VueRouter);
Vue.use(Auth, {
	issuer: 'https://dev-569380.okta.com/oauth2/default',
	client_id: '0oa34ugtluDIJ39ME4x6',
	redirect_uri: 'https://flutr-1e033.firebaseapp.com/implicit/callback',
	scope: 'openid profile email'
});

// Vue.use(Auth, {
// 	issuer: 'https://dev-569380.okta.com/oauth2/default',
// 	client_id: '0oa358qurP5ZWwGBA4x6',
// 	redirect_uri: 'http://localhost:8080/implicit/callback',
// 	scope: 'openid profile email'
// });



const router = new VueRouter({ 
	mode: 'history',
	routes: [
	{ name:'ShipmentsTable', path: '/shipments', component: shipments, meta: { requiresAuth: true }},
	{ name:'Butterflies', path: '/butterflies', component: butterflies, meta: { requiresAuth: true }},
	{ name:'Plants', path: '/plants', component: plants, meta: { requiresAuth: true }},
	{ name:'Shipment', path: '/shipment/:id', component: batch, meta: { requiresAuth: true }},
	{ name:'Batch', path: '/shipment/:id/emergence/:id2', component: emergence, meta: { requiresAuth: true }},
	{ name:'EditButterfly', path: '/butterfly/:id', component: editButterfly, meta: { requiresAuth: true }},
	{ name:'Import/Export', path: '/excel', component: excel, meta: { requiresAuth: true }},
	{ name:'ShipmentSearch', path: '/search/shipment', component: shipmentSearch, meta: { requiresAuth: true }},
	{ name:'Customize', path: '/customize', component: customize, meta: { requiresAuth: true }},
	{ name:'ButterflySearch', path: '/search/butterfly', component: butterflySearch},
	{ name:'Statistics', path: '/stats', component: stats},
	{ name:'ButterflyGallery', path: '/gallery/butterflies', component: butterflyGallery},
	{ name:'PlantGallery', path: '/gallery/plants', component: plantGallery},
	{ name:'ButterflyView', path: '/gallery/butterflies/:id', component: butterflyView},
	{ name:'HomePage', path: '/', component: home},
	{ name:'Developer', path: '/developer', component: developer},
	{
		path: '/implicit/callback',
		component: Auth.handleCallback()
	},
	]
	});

router.beforeEach(Vue.prototype.$auth.authRedirectGuard())

export default router

new Vue({
	el: '#navBar',
	router,
	render: h => h(navBar)
})
